import { ConnectKitButton } from 'connectkit';
import { default as WalletIcon } from '../../assets/icons/wallet.svg?react';
import { useModalState } from '../../hooks/useModalState';
import { useTailwindBreakpoint } from '../../hooks/useTailwindBreakpoint';
import { truncateAddress } from '../../lib/stringHelpers';
import { Button, ButtonSize } from '../catalyst-ui-kit/button';
import { ConnectedWalletDropdown } from './ConnectedWalletDropdown';

type ConnectButtonProps = {
  label?: string;
  className?: string;
  onClick?: () => void;
  size?: ButtonSize;
};

export function ConnectButton({ label = 'Connect', className, onClick, size }: ConnectButtonProps) {
  const isLg = useTailwindBreakpoint('lg');
  const { setAccountModal } = useModalState();

  return (
    <ConnectKitButton.Custom>
      {({ isConnected, show, address, ensName }) => {
        if (isConnected && address) {
          return isLg ? (
            <ConnectedWalletDropdown
              size={size}
              address={address}
              ensName={ensName}
              className={className}
            />
          ) : (
            <Button
              size={size}
              color="tertiary"
              className={className}
              onClick={() => {
                if (onClick) onClick();
                setAccountModal('open');
              }}
            >
              <WalletIcon />
              {ensName || truncateAddress(address)}
            </Button>
          );
        }

        return (
          <Button
            size={size}
            color="blue"
            className={className}
            onClick={() => {
              if (onClick) onClick();
              if (show) show();
            }}
          >
            {label}
          </Button>
        );
      }}
    </ConnectKitButton.Custom>
  );
}
